import { Capacitor } from '@capacitor/core';

const platform = {
  get isNative(): boolean {
    return Capacitor.isNativePlatform();
  },
  get isWeb(): boolean {
    return !Capacitor.isNativePlatform();
  },
  get isIOS(): boolean {
    return Capacitor.getPlatform() === 'ios';
  },
  get isAndroid(): boolean {
    return Capacitor.getPlatform() === 'android';
  },
  get current(): 'ios' | 'android' | 'web' {
    return Capacitor.getPlatform() as 'ios' | 'android' | 'web';
  },
  isPluginAvailable(name: string): boolean {
    return Capacitor.isPluginAvailable(name);
  },
} as const;

export { platform };
